import { Form, Input } from "antd";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

export default function UDFInput({
  title = "Title",
  isFormItem = true,
  className,
  placeholder = "",
  formItemName = "",
  required = true,
  params,
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const renderField = () => (
    <Input
      {...params}
      placeholder={placeholder}
      style={style}
      disabled={disabled}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        className={className}
        label={title}
        name={formItemName}
        initialValue={null}
        rules={required && [{ required: true, message: `Enter ${title}` }]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
